const STEPS = [
  {
    step: "Paso 01",
    title: "Evaluamos tu vivienda",
    text: "Visitamos la propiedad, analizamos su potencial y te proponemos un plan de mejora claro y honesto.",
  },
  {
    step: "Paso 02",
    title: "Asumimos la reforma",
    text: "Si es necesaria, nos hacemos cargo de los costes de reforma y revalorización del inmueble.",
  },
  {
    step: "Paso 03",
    title: "Nos convertimos en tu inquilino",
    text: "Firmamos contrato directamente contigo. A partir de ahí, THE NEXT ROOM es responsable de todo.",
  },
  {
    step: "Paso 04",
    title: "Tú cobras puntual cada mes",
    text: "Ingresamos tu renta a principio de mes. Sin impagos. Sin llamadas de inquilinos. Cero preocupaciones.",
  },
];

export default function Process() {
  return (
    <section
      id="proceso"
      data-testid="process-section"
      className="nr-section nr-bg-soft"
    >
      <div className="nr-container">
        <div className="max-w-2xl mb-14">
          <span className="nr-eyebrow">Cómo lo hacemos</span>
          <h2 className="nr-h2 mt-4">Un proceso simple, en cuatro pasos.</h2>
          <p className="mt-5 text-[16px] nr-text-soft">
            Desde la primera visita hasta el ingreso puntual cada mes. Todo el
            recorrido está pensado para que tú no tengas que mover un dedo.
          </p>
        </div>

        <div className="relative">
          <div
            aria-hidden
            className="hidden md:block absolute top-12 left-0 right-0 h-px bg-[#EAEAEA]"
          />
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-6 relative">
            {STEPS.map((s, i) => (
              <div
                key={s.step}
                data-testid={`process-step-${i + 1}`}
                className="relative"
              >
                <div className="hidden md:flex absolute -top-1 left-0 h-3 w-3 rounded-full bg-[#43A4A8] ring-4 ring-[#F7F7F7]" />
                <div className="md:pt-10">
                  <div className="nr-step-num">{s.step}</div>
                  <h3 className="nr-h3 mt-3">{s.title}</h3>
                  <p className="mt-3 text-[14px] nr-text-soft leading-relaxed">
                    {s.text}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
